import React from "react";
import "./Creators.css";

export default function Creators() {
  return (
    <div className="agn-creators-wrapper">
      <div className="container">
        <div className="bento-grid">
          {/* Main Hero Card */}
          <div className="bento-main-card">
            <h2>Financial Growth Now Accessible for Everyone
            </h2>
            <h3>
              AGN simplifies complex financial systems into a user-friendly earning model, allowing individuals to:

            </h3>
            <div className="bento-benefits">
              <div className="bento-benefit-tag">
                <img src="../assets/svg/home/tick.svg" width="16" alt="tick" />
                Generate passive monthly income

              </div>
              <div className="bento-benefit-tag">
                <img src="../assets/svg/home/tick.svg" width="16" alt="tick" />
                Participate in global financial mechanisms


              </div>
              <div className="bento-benefit-tag">
                <img src="../assets/svg/home/tick.svg" width="16" alt="tick" />
                Build scalable business networks

              </div>
            </div>
          </div>

          {/* Service Card 1 */}
          <div className="bento-service-card">
            <div className="bento-icon">
              <img
                src="../assets/svg/home/easy_integration_01.svg"
                alt="icon"
              />
            </div>
            <h4>Dual Income Engine
            </h4>
            <p>
              Leverage both Sale & Leaseback and Securities Lending models to generate diversified income streams.


            </p>
          </div>

          {/* Service Card 2 */}
          <div className="bento-service-card">
            <div className="bento-icon">
              <img
                src="assets/svg/home/multi_exchange_support_01.svg"
                alt="icon"
              />
            </div>
            <h4>Asset-Backed Opportunities
            </h4>
            <p>
              Participate in structured investments backed by real-world and financial market assets.

            </p>
          </div>

          {/* Service Card 3 */}
          <div className="bento-service-card">
            <div className="bento-icon">
              <img
                src="assets/svg/home/advanced_algorithms.svg"
                alt="icon"
              />
            </div>
            <h4>Scalable Earnings System

            </h4>
            <p>
              Flexible participation with multiple asset tiers and growth-based rewards.

            </p>
          </div>

          {/* Service Card 4 */}
          <div className="bento-service-card">
            <div className="bento-icon">
              <img
                src="assets/svg/home/user_friendly_interface.svg"
                alt="icon"
              />
            </div>
            <h4> Transparent Structure
            </h4>
            <p>
              Clearly defined income plans with zero admin charges and structured payouts.

            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
